/** @format */

import { CommonModule } from '@angular/common';
import { HomefieldButtonModule } from '../button';
import { HomefieldHeroBannerComponent } from './hero-banner.component';
import { NgModule } from '@angular/core';

@NgModule({
	imports: [CommonModule, HomefieldButtonModule],
	declarations: [HomefieldHeroBannerComponent],
	exports: [HomefieldHeroBannerComponent]
})
export class HomefieldHeroBannerModule {}
